import {createEntitySlice} from 'utils/createEntitySlice';
import {Program} from 'types/program';
import {ProgramsThunks} from 'features/programs/programsThunks';

// Centralized tabs configuration for program pages
export const PROGRAM_TABS = [
  'Report Templates',
  'Custom Data',
  'Cards',
  'Services',
  'Billing Rules',
  'Billing Solutions',
  'Fax Cover Sheet',
];

export type ProgramTab = (typeof PROGRAM_TABS)[number];

export interface ProgramState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  programs?: any;
  pagy?: any;
  program?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ProgramState = {
  status: 'idle',
  error: null,
  programs: [],
  program: {name: '', nameAlias: ''},
  pagy: {},
  isEditing: false,
  activeTab: 'Billing Solutions',
};

const programsSlice = createEntitySlice<Program>({
  name: 'program',
  initialState,
  thunks: ProgramsThunks,
  entityKey: 'program',
  entitiesKey: 'programs',
  reducers: {},
});

export const {
  setEntity: setProgram,
  setIsEditing,
  setActiveTab,
} = programsSlice.actions;
export {initialState as programInitialState};
export default programsSlice.reducer;
